<template>
  <div>
    <el-form
      ref="searchForm"
      :inline="true"
      class="searchBoxLine"
      :model="searchForm"
      :rules="searchRules"
    >
      <el-form-item label="项目名称:" clearable prop="projectName">
        <el-input
          v-model="searchForm.projectName"
          maxlength="20"
          placeholder="请输入项目名称"
          clearable
        />
      </el-form-item>
      <el-form-item label="退换货合同编号:" clearable prop="newContractNum">
        <el-input
          v-model="searchForm.newContractNum"
          maxlength="20"
          placeholder="请输入退换货合同编号"
          clearable
        />
      </el-form-item>
      <el-form-item label="原合同编号:" clearable prop="oldContractNum">
        <el-input
          v-model="searchForm.oldContractNum"
          maxlength="20"
          placeholder="请输入原合同编号"
          clearable
        />
      </el-form-item>
      <el-form-item label="部门:" clearable prop="salesPersonDeptName">
        <el-input
          v-model="searchForm.salesPersonDeptName"
          maxlength="20"
          placeholder="请输入部门"
          clearable
        />
      </el-form-item>
      <el-form-item label="区域:" clearable prop="salesArea">
        <el-input
          v-model="searchForm.salesArea"
          maxlength="20"
          placeholder="请输入区域"
          clearable
        />
      </el-form-item>
      <el-form-item label="合同时间:">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.startTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerStartOptions"
            />
          </div>
          <div style="display: inline-block; width: 10px; text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.endTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerEndOptions"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="外销:" clearable prop="salesPersonName">
        <el-input
          v-model="searchForm.salesPersonName"
          maxlength="20"
          placeholder="请输入外销"
          clearable
        />
      </el-form-item>

      <el-form-item label="客户名称:" clearable prop="orderUnitName">
        <el-input
          v-model="searchForm.orderUnitName"
          maxlength="20"
          placeholder="请输入客户名称"
          clearable
        />
      </el-form-item>

      <el-form-item label="退换货类型：" prop="reasonType">
        <el-select
          v-model="searchForm.reasonType"
          placeholder="请选择退换货类型"
        >
          <el-option
            v-for="(item, index) in returnList"
            :key="index"
            :label="displayReasonType(item)"
            :value="item"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="已分配比例：" class="undistributed-money">
        <el-input-number
          v-model="searchForm.startRatio"
          controls-position="right"
          :min="0"
          :max="searchForm.endRatio ? searchForm.endRatio : 999.99"
          placeholder="请输入比例"
        />
        <span> - </span>
        <el-input-number
          v-model="searchForm.endRatio"
          controls-position="right"
          :min="0"
          :max="999.99"
          placeholder="请输入比例"
          @change="endRatioChange"
        />
      </el-form-item>

      <el-form-item label="流程状态：" prop="contractProcessStatus">
        <el-select v-model="searchForm.flowName" placeholder="请选择流程状态">
          <el-option
            v-for="(item, index) in statusList"
            :key="index"
            :label="item.label"
            :value="item.label"
          />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" :loading="Loading" @click="searchData">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableDataList" border style="width: 100%">
        <el-table-column label="项目名称" align="left" min-width="200">
          <template v-slot="{ row }">
            <el-button type="text" class="el-btn-text-left" @click="jumpProjectDetail(row)">
              {{ row.projectName }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="newContractNum"
          label="退换货合同编号"
          align="left"
          width="150"
        />
        <el-table-column
          prop="oldContractNum"
          label="原合同编号"
          align="left"
          width="150"
        />
        <el-table-column
          prop="orderUnitName"
          label="客户名称"
          align="left"
          width="150"
        />
        <el-table-column
          prop="contractType"
          label="合同类型"
          align="left"
          width="120"
        />
        <el-table-column
          prop="reasonType"
          label="退换货类型"
          align="left"
          width="150"
        >
          <!-- D8：列值为落库值（如“产品发运错误”），展示层统一经 displayReasonType 映射 -->
          <template v-slot="{ row }">
            {{ displayReasonType(row.reasonType) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="salesPersonName"
          label="外销"
          align="left"
          width="120"
        />
        <el-table-column
          prop="salesPersonDeptName"
          label="部门"
          align="left"
          width="120"
        />
        <el-table-column
          prop="salesArea"
          label="区域"
          align="left"
          width="120"
        />
        <el-table-column
          prop="createdTime"
          label="合同时间"
          align="left"
          width="140"
        />
        <el-table-column label="已分配金额/比例" align="right" header-align="left" width="120">
          <template v-slot="{ row }">
            {{ row.assignedAmount }}/{{ row.assignedRatio * 100 }}%
          </template>
        </el-table-column>
        <el-table-column
          prop="contractProcessStatus"
          label="流程状态"
          align="left"
          width="120"
        >
          <template v-slot="{ row }">
            <span v-if="row.contractStatus === 3">
              {{ "待发布" }}
            </span>
            <span v-if="row.contractStatus === 4">
              <template v-if="row.contractProcessStatus === 1">
                {{ "已发布" }}
              </template>
              <template v-if="row.contractProcessStatus === 2">
                {{ "待分配" }}
              </template>
              <template v-if="row.contractProcessStatus === 4">
                {{ "已分配" }}
              </template>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="left" width="210">
          <template v-slot="{ row }">
            <!-- {{ row.contractProcessStatus }}
            {{ row.contractType }} -->
            <el-button
              v-if="
                isHandleDistriButtonShow(row)
              "
              type="text"
              @click="handleDistribution(row)"
            >
              分配
            </el-button>
            <el-button type="text" @click="showeContractEnclosure(row)">
              合同附件
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.pageNum"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>

    <!-- 合同附件 -->
    <el-dialog title="合同附件" :visible.sync="contractVisible" width="800px">
      <contract-attachment v-if="contractVisible" :contract-id="contractId" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="contractVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 分配查看 -->
    <distribution-detail-dialog ref="distributionDetail" @on-ok="queryDdata" />
  </div>
</template>

<script>
// 合同附件
// 分配查看
import distributionDetailDialog from '@/views/assistantContractList/return-replacement-contract/distributionDetailDialog.vue';
import { checkDealtContractAssign } from '@/API';
import { getBusinessList } from '@/API/international';
import contractAttachment from '../../returnExchange/Chief/commom/internationalfileDialog.vue';
import { displayReasonType } from '@/constant';

export default {
  name: 'InternationalReturnsAndExchangeList',
  components: {
    contractAttachment,
    distributionDetailDialog
  },
  data () {
    return {
      pickerEndOptions: {
        disabledDate: (time) => {
          if (this.searchForm.startTime) {
            let date = new Date(this.searchForm.startTime);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      pickerStartOptions: {
        disabledDate: (time) => {
          if (this.searchForm.endTime) {
            return time.getTime() > new Date(this.searchForm.endTime).getTime();
          } else {
            return false;
          }
        }
      },
      searchForm: {},
      contractNum: '',
      contractId: '',
      contractVisible: false,
      tableLoading: false,
      tableDataList: [],
      Loading: false,
      returnList: ['市场销售原因', '产品缺货或停产', '其他特殊原因', '其他特殊原因（税率）', '齐套不提货撤单', '产品功能问题'],
      statusList: [
        {
          label: '待发布',
          value: 3,
          code: 1
        },
        {
          label: '已发布',
          value: 4,
          code: 1
        },
        {
          label: '待分配',
          value: 4,
          code: 2
        },
        {
          label: '已分配',
          value: 4,
          code: 4
        }
      ],
      page: {
        pageSize: 10,
        pageNum: 1,
        total: 0
      },
      searchRules: {
        projectName: [
          { required: false, message: '请输入项目名称', trigger: 'blur' },
          { min: 0, max: 20, message: '最大长度不能超过20个字符', trigger: 'blur' }
        ],
        oldContractNum: [
          { required: false, message: '请输入原合同编号', trigger: 'blur' },
          { min: 0, max: 20, message: '最大长度不能超过20个字符', trigger: 'blur' }
        ],
        newContractNum: [
          { required: false, message: '请输入退换货合同编号', trigger: 'blur' },
          { min: 0, max: 20, message: '最大长度不能超过20个字符', trigger: 'blur' }
        ],
        salesArea: [
          { required: false, message: '请输入区域', trigger: 'blur' },
          { min: 0, max: 20, message: '最大长度不能超过20个字符', trigger: 'blur' }
        ],
        salesPersonDeptName: [
          { required: false, message: '请输入部门', trigger: 'blur' },
          { min: 0, max: 20, message: '最大长度不能超过20个字符', trigger: 'blur' }
        ],
        salesPersonName: [
          { required: false, message: '请输入外销', trigger: 'blur' },
          { min: 0, max: 20, message: '最大长度不能超过20个字符', trigger: 'blur' }
        ],
        orderUnitName: [
          { required: false, message: '请输入客户名称', trigger: 'blur' },
          { min: 0, max: 20, message: '最大长度不能超过20个字符', trigger: 'blur' }
        ]
      },
      userIdList: [
        'R22889', // userName: "Jessica"
        'R19724', // userName: "李凯西"
        'R13678', // userName: "吴宗妮"
        'R19102', // userName: "裴氏云英BuiThiVanAnh"
        'R21081', // userName: "王慧1"
        'R12610', // userName: "仇嘉懿 Regina QIU"
        'R14996' // userName: "嶋崎あい"
      ]
    };
  },

  computed: {
    isShowBtn () {
      return window._env_.NODE_ENV !== 'pro';
    },
    processStatus () {
      return (data) => {
        console.log('ssss----->>>>>>>>', data);
        // return this.statusList[data - 1].label;
      };
    },
    isReplace () {
      return (data) => {
        return data.includes('换货合同') || data.includes('价外费用合同') || data.includes('退货');
      };
    },
    // 分配按钮只开放给商务组长
    isHandleDistri () {
      return this.userIdList.some((item) => item === this.$store.state.user.userId);
    }
  },

  created () {
    this.queryDdata();
  },

  methods: {
    displayReasonType,
    endRatioChange (e) {
      if (e < this.searchForm.startRatio) {
        this.searchForm.startRatio = e;
      }
    },
    isHandleDistriButtonShow (row) {
      if (row.contractProcessStatus === 2 && row.contractType.includes('换货合同')) {
        return true;
      } else if (row.contractProcessStatus === 2 && (row.contractType.includes('退货') || row.contractType.includes('价外费用合同')) && this.isHandleDistri) {
        return true;
      }
      return false;
    },
    queryDdata () {
      this.tableLoading = true;
      let params = {
        ...this.searchForm,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize
      };

      getBusinessList(params).then((res) => {
        this.tableLoading = false;
        let { status, data } = res.data;
        if (status === '200') {
          this.tableDataList = data.list;
          this.page.total = data.total;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },

    handerSizeChange () {
      this.page.pageNum = 1;
      this.queryDdata();
    },

    handerCurrentChange () {
      this.queryDdata();
    },

    searchData () {
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          this.page.pageNum = 1;
          this.queryDdata();
        } else {
          return false;
        }
      });
    },
    resetForm () {
      this.searchForm = {};
      this.$refs.searchForm.resetFields();
      this.page.pageNum = 1;
      this.queryDdata();
    },

    // 项目详情
    jumpProjectDetail ({ contractType, id, newContractNum }) {
      let query = { contractType, 'contractId': id, number: newContractNum };
      let routeUrl = this.$router.resolve({ path: 'checkInternationalChange', query });
      window.open(routeUrl.href, '_blank');
    },

    // 分配
    handleDistribution (row) {
      checkDealtContractAssign({ reNewContractNum: row.newContractNum })
        .then((res) => {
          let { status, data } = res.data;
          if (status === '200' && data) {
            this.openDistributionPage(row);
          } else {
            this.queryDdata();
          }
        });
    },

    // 打开分配界面
    openDistributionPage (row, type = '') {
      let { id, newContractNum, oldContractNum, contractType } = row;
      let paramsStr = `internationalPay?contractId=${id}&newContractNum=${newContractNum}&oldContractNum=${oldContractNum}&contractType=${contractType}&type=${type}`;
      let pathUrl = `${window.origin}/${paramsStr}`;
      window.open(pathUrl);
    },

    // 合同附件
    showeContractEnclosure (row) {
      this.contractId = row.id;
      this.contractVisible = true;
    },

    // 分配查看
    showAllocationDetails (row) {
      let data = JSON.parse(JSON.stringify(row));
      this.$refs.distributionDetail.openDialog(data);
    }

  }

};
</script>

<style scoped>
.undistributed-money .el-input {
  width: 120px !important;
}
</style>
